export const useEventDay = (item) => {
	// The day number now comes from the record. It used to come from this table:
	//
	//     { num: 6, label: 'Saturday', date: 18 }
	//     { num: 7, label: 'Sunday',   date: 19 }
	//
	// — the 2025 festival dates. OHC 2026 is Oct 17-18, so every Saturday event
	// rendered "SATURDAY, OCT. 18" (the weekday was computed from the data and
	// correct; only the number was last year's) and every Sunday event read
	// "SUNDAY, OCT. 19". Deriving it means there is nothing to bump next year.
	//
	// UTC components, deliberately: Airtable serialises an event's LOCAL
	// wall-clock time with a `Z` on the end, so "2026-10-17T13:00:00.000Z" is the
	// 1 PM slot, not 13:00 UTC. Converting to America/Chicago — which this
	// composable used to do — is the obviously-correct-looking move that shifts
	// early events onto the previous day (Asana O2-34). Templates/Events/page.vue
	// reads UTC components for the same reason; this now matches it.
	const raw = item?.fields?.['Date'];
	if (!raw) return { eventDay: undefined };

	const date = new Date(raw);
	if (Number.isNaN(date.getTime())) return { eventDay: undefined };

	let num = date.getUTCDay();
	if (num === 0) num = 7;

	// Weekend-only, preserving the previous behaviour: the old table held Sat and
	// Sun alone, so a weekday event returned undefined and the card hid the block
	// entirely. OHC 2026 runs Sat/Sun, so nothing is affected today — but a
	// midweek programme would still be dateless, which is worth revisiting.
	if (num !== 6 && num !== 7) return { eventDay: undefined };

	return {
		eventDay: {
			num,
			label: date.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'long' }),
			date: date.getUTCDate(),
		},
	};
};
